module.exports = __webpack_public_path__ + "static/media/taneli-lahtinen-1027248-unsplash-sm.831f1f50.jpg";